import React from "react"
import { ISchedulePatternTemplate, IScheduleDailyTimelineData, IScheduleShift } from "../../../models"
import TimelineTable from "../../../components/schedule/daily_timeline/TimelineTable"
import strings from "../../../localization/strings"
import autobind from "class-autobind"
import AppStateStore from "../../../stores/AppStateStore"
import AccountStore from "../../../stores/AccountStore"
import AddIcon from "material-ui/svg-icons/content/add-circle"
import * as utils from "../../../helpers/utils"
import * as timeHelper from "../../../helpers/timeHelper"
import * as permissionHelper from "../../../helpers/permissionHelper"
import AuthenticationStore from "../../../stores/AuthenticationStore"
interface IProps {
	patternTemplates: ISchedulePatternTemplate[]
	handleUpdate(editPatternTemplate: ISchedulePatternTemplate): void
	handleSelect(selectedPatternTemplates: ISchedulePatternTemplate[]): void
	handleAddShiftTemplate(patternTemplate: ISchedulePatternTemplate): void
	handleUpdateTimelineData(timelineItem: IScheduleDailyTimelineData, rowNumber: number, orderNumber: number): void
	checkValidateNewTimeline(timelineItem: IScheduleDailyTimelineData, rowNumber: number, orderNumber: number): boolean
	handleDeleteTimelineItem(rowNumber: number, orderNumber: number): void
	handleUpdateTimelineItem(item: IScheduleShift, rowNumber: number, orderNumber: number)
}
interface IState {
	width: number
}

export default class PatternTemplateTimelineTable extends React.Component<IProps, IState> {
	constructor(props) {
		super(props)
		this.state = {
			width: 1200
		}
		autobind(this)
	}

	componentWillMount() {
		this.updateDimensions()
	}

	componentDidMount() {
		window.addEventListener("resize", this.updateDimensions)
		AppStateStore.on("change", this.updateDimensions)
	}
	componentWillUnmount() {
		window.removeEventListener("resize", this.updateDimensions)
		AppStateStore.removeListener("change", this.updateDimensions)
	}

	updateDimensions() {
		const leftNavWidth = AppStateStore.getExpandNav() === "expanded" ? 224 : 80
		const width = window.innerWidth - leftNavWidth - 13 * 2 - 20 * 2
		this.setState({ width })
	}

	getIimelineItemRenderElement(timelineItem: IScheduleDailyTimelineData, rowNumber: number, orderNumber: number) {
		const timelineItemData = this.props.patternTemplates[rowNumber].ShiftTemplates[orderNumber]
		const position = AccountStore.getCurrentAccount().PositionDefinitions.find((item) => item.Id === timelineItemData.PositionId)
		const backgroundColor = position && position.Color ? position.Color : AccountStore.getPositionDefaultColor()
		const timeInfo = `${timeHelper.getTimeStringSimpleFormatFromSimpleTime(timelineItem.StartTime)}-${timeHelper.getTimeStringSimpleFormatFromSimpleTime(timelineItem.EndTime)}`
		return (
			<div style={{ backgroundColor, height: 46, textAlign: "center", display: "flex" }}>
				<div style={{ flex: 0.2 }} />
				<div style={{ color: "white", flex: 1, paddingTop: 13, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }} title={timeInfo}>
					{timeInfo}
				</div>
				<div style={{ flex: 0.1 }} />
				<div style={{ flex: 1, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", height: 30, marginTop: 8, fontSize: 15, borderRadius: 15, backgroundColor: utils.getMaterial900ColorFrom500Color(backgroundColor), color: "rgba(254, 254, 254, 0.5)", }}>
					<div
						style={{ paddingLeft: 10, paddingRight: 10, marginTop: 5, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
						title={timelineItemData.Name}
					>
						{timelineItemData.Name}
					</div>
				</div>
				<div style={{ flex: 0.2 }} />
			</div>
		)
	}

	render() {
		const timelineData: IScheduleDailyTimelineData[][] = new Array(this.props.patternTemplates.length)
		this.props.patternTemplates.forEach((patternTemplate, index) => {
			const dailyTimelineData: IScheduleDailyTimelineData[] = []
			patternTemplate.ShiftTemplates.forEach((shiftTemplate) => {
				dailyTimelineData.push({ StartTime: shiftTemplate.StartTime, EndTime: shiftTemplate.EndTime, Breaks: shiftTemplate.Breaks })
			})
			timelineData[index] = dailyTimelineData
		})
		return (
			<TimelineTable
				items={this.props.patternTemplates}
				timelineData={timelineData}
				timelineItemRenderElement={this.getIimelineItemRenderElement}
				leftSideColumns={[
					{
						HeaderLabel: strings.Name,
						HeaderStyle: { textAlign: "center" },
						Col: (row) =>
							<div style={{ position: "relative" }}>
								<div className="TextOverflow" style={{ paddingRight: 30 }} title={row.Name}>{row.Name}</div>
								{permissionHelper.hasPermission(AuthenticationStore.Permissions.Schedule.EditAccountSchedule) &&
									<AddIcon
										style={{ position: "absolute", right: 10, top: -2, cursor: "pointer" }}
										onClick={(e) => {
											e.stopPropagation()
											this.props.handleAddShiftTemplate(row)
										}}
									/>
								}
							</div>,
						ColStyle: { textAlign: "left", cursor: "default", paddingLeft: 0, paddingRight: 0 }
					}
				]}
				multiSelectable={permissionHelper.hasPermission(AuthenticationStore.Permissions.Schedule.DeleteAccountSchedule)}
				selectable={permissionHelper.hasPermission(AuthenticationStore.Permissions.Schedule.DeleteAccountSchedule)}
				handleUpdate={this.props.handleUpdate}
				readonly={!permissionHelper.hasPermission(AuthenticationStore.Permissions.Schedule.EditAccountSchedule)}
				handleSelect={this.props.handleSelect}
				timelineTableWidth={this.state.width}
				leftSideWidth={300}
				handleUpdateTimelineData={this.props.handleUpdateTimelineData}
				checkValidateNewTimeline={this.props.checkValidateNewTimeline}
				handleDeleteTimelineItem={this.props.handleDeleteTimelineItem}
				handleUpdateTimelineItem={this.props.handleUpdateTimelineItem}
			/>
		)
	}
}
